"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M17.2928932,15.8535534 L18.7071068,14.4393398 L12.7071068,8.43933983 C12.3466228,8.07885587 11.7793918,8.05112633 11.3871006,8.35615122 L11.2928932,8.43933983 L5.29289322,14.4393398 L6.70710678,15.8535534 L12,10.561455 L17.2928932,15.8535534 Z"
  });
}.bind(void 0));

exports.default = _default;